import React from 'react';

export const LocationMarker = () => (
  <svg
    width="20"
    height="30"
    viewBox="0 0 20 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4176_3702)">
      <path
        d="M9.9998 0.800049C4.47296 0.800049 0.00292969 5.26969 0.00292969 10.796C0.00292969 18.293 9.9998 29.36 9.9998 29.36C9.9998 29.36 19.9967 18.293 19.9967 10.796C19.9967 5.26969 15.5266 0.800049 9.9998 0.800049ZM9.9998 14.366C9.0529 14.366 8.14478 13.9899 7.47521 13.3204C6.80565 12.6509 6.42949 11.7429 6.42949 10.796C6.42949 9.84923 6.80565 8.94118 7.47521 8.27168C8.14478 7.60217 9.0529 7.22605 9.9998 7.22605C10.9467 7.22605 11.8548 7.60217 12.5244 8.27168C13.194 8.94118 13.5701 9.84923 13.5701 10.796C13.5701 11.7429 13.194 12.6509 12.5244 13.3204C11.8548 13.9899 10.9467 14.366 9.9998 14.366Z"
        fill="#005EE0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4176_3702">
        <rect
          width="20"
          height="28.56"
          fill="white"
          transform="translate(0 0.800049)"
        />
      </clipPath>
    </defs>
  </svg>
);
